document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-card-mini').forEach(card => {
    const hiddenInput = card.querySelector('input[name="id"]');
    const qtyInput    = card.querySelector('.qty-input');
    const minus       = card.querySelector('.qty-btn.minus');
    const plus        = card.querySelector('.qty-btn.plus');
    const swatches    = card.querySelectorAll('.pcm-swatch-input');

    // Quantity
    if (minus && plus && qtyInput) {
      minus.onclick = () => { if (+qtyInput.value > 1) qtyInput.value--; };
      plus.onclick  = () => qtyInput.value++;
    }

    if (swatches.length === 0) return;

    const update = () => {
      const lastChecked = card.querySelector('.pcm-swatch-input:checked:last-of-type');
      if (hiddenInput && lastChecked) {
        hiddenInput.value = lastChecked.value;
      }

      card.querySelectorAll('.pcm-swatch-label').forEach(l => l.classList.remove('selected'));
      card.querySelectorAll('.pcm-swatch-input:checked').forEach(input => {
        const label = input.closest('.pcm-swatch-element')?.querySelector('.pcm-swatch-label');
        if (label) label.classList.add('selected');
      });

      card.querySelectorAll('.option-value').forEach(el => {
        const idx = el.dataset.index;
        const checkedInput = card.querySelector(`.pcm-swatch-input[data-index="${idx}"]:checked`);
        if (checkedInput) {
          const title = checkedInput.closest('.pcm-swatch-element')?.querySelector('.pcm-swatch-label')?.title;
          if (title) el.textContent = title;

          
        }
      });
    };

    update();
    swatches.forEach(s => s.addEventListener('change', update));
  });

  
});
